import React, {useEffect, useState} from "react"
import {cloneOrder, Schema} from "../utils";
import {useCore} from "../hooks";
import {useNavigate, useParams} from "react-router";
import {Customer, Order} from "depoto-core";
import {Btn, Loader, ModalNotesOnExistingOrder, OrderFinalSummary} from "../components";
import {toast} from "react-toastify";
import {useConfirmationModal} from "../utils/hooks/useConfirmationModal.tsx";
import {printDocument} from "../utils/print.ts";

export const ReservationDetail: React.FC = () => {
  const params = useParams()
  const navigate = useNavigate()
  const { core, currentOrder, setCurrentOrder } = useCore()
  const [order, setOrder] = useState<Order>()
  const { ConfirmationModalComponent, showConfirmationModal, isConfirmed: isReservationDeletionConfirmed } = useConfirmationModal()

  useEffect(() => {
    if (params?.id) {
      getOrder(Number(params.id))
    }
  }, [params])

  useEffect(() => {
    if (isReservationDeletionConfirmed) {
      deleteReservation()
    }
  }, [isReservationDeletionConfirmed])

  const getOrder = async (orderId: number) => {
    const o = await core.services.order.getById(orderId, Schema.order.detail)
    setOrder(o)
  }

  const backToList = () => {
    navigate('/checkout-detail/reservations')
  }

  const showPdf = () => {
    core.services.download.downloadDocumentAndShowInNewWindow(order.reservationReceiptUrl, false)
  }

  const printPdf = () => {
    if (window._depoto) {
      printDocument(order.reservationReceiptUrl, false, true, core)
      // printDocument(currentOrder.reservationUrl, false, false, core) // a4
    } else {
      showPdf()
    }
  }

  const cancelReservation = async () => {
    showConfirmationModal()
  }

  const deleteReservation = async () => {
    const errors = await core.services.order.deleteReservation(order)
    if (Array.isArray(errors)) {
      errors.forEach(e => {
        toast.error(e)
      })
    } else {
      toast.warning('Rezervace zrušena')
      backToList()
    }
  }

  const assignCustomer = async (customer: Customer | null) => {
    await core.services.order.updateOrderPart({
      id: order.id,
      customer: customer ? customer : null,
    })
    getOrder(Number(params.id))
  }

  const payReservation = () => {
    cloneOrder({ orderToClone: order, currentOrder, setCurrentOrder })
    navigate('/dashboard')
  }

  return order ? (
    <div className="h-body p-6 flex flex-col overflow-y-auto">
        <div className="bg-white border-b-1 border-solid border-border-light rounded-md p-6 mb-6">
          <div className="flex flex-row items-center">
            <h1 className="font-bold mr-4 text-xl">Rezervace: {order?.reservationNumber}</h1>
            <Btn className="btn-base-100" children={'Zpět na výpis'} icon={'fa-arrow-left'} onClick={backToList}/>
          </div>
          <div className="flex flex-row gap-2 mt-4">
            <Btn className="btn-base-100" children={'Zrušit rezervaci'} icon={'far fa-rotate-left'} onClick={cancelReservation}/>
            <ModalNotesOnExistingOrder order={order} onUpdate={() => getOrder(Number(params.id))} />
            <Btn className="btn-base-100" children={'Vytisknout potvrzení'} icon={'far fa-print'} onClick={printPdf}/>
            <Btn className="btn-primary" children={'Zaplatit rezervaci'} icon={'far fa-shopping-cart'} onClick={payReservation}/>
          </div>
        </div>
      <div className="w-1/2">
        {<OrderFinalSummary order={order} isReservation={true} showCustomerHeader={false} onExistingOrderCustomerChange={assignCustomer} />}
      </div>
      <ConfirmationModalComponent title={'Opravdu si přejete zrušit rezervaci?'}
                                  confirmBtnLabel={'Zrušit rezervaci'}/>
    </div>
  ) : <Loader />
}
